import React, { Component } from 'react';
import bulmaCarousel from 'bulma-carousel';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faChevronRight, faChevronLeft
} from '@fortawesome/free-solid-svg-icons';


class ImageModal extends Component {
  componentDidUpdate() {
    // find a way to do this so that the gallery doesn't flicker
    bulmaCarousel.attach();
  }

  render() {
    let photos = [];
    if (this.props.obj && this.props.obj.photos && this.props.obj.photos.length) {
      photos = this.props.obj.photos;
    }
    console.log(photos)
    return (
      <div className={`modal image-modal ${this.props.show ? 'is-active' : ''}`}>
        <div className="modal-background"></div>
        <div className="modal-content">
          <div className='carousel carousel-animated carousel-animate-slide'>
            <div className='carousel-container'>
              {photos && photos.map((item, i) => (
                <div className={`carousel-item has-background ${i === 0 ? 'is-active' : ''}`} key={item.uid}>
                  <img className="is-background" src={item.url} alt={item.name} />
                  {item.description && <div className="title">{item.description}</div>}
                </div>
              ))}
            </div>
            <div className="carousel-navigation is-overlay">
              <div className="carousel-nav-left">
                <FontAwesomeIcon icon={faChevronLeft} />
              </div>
              <div className="carousel-nav-right">
                <FontAwesomeIcon icon={faChevronRight} />
              </div>
            </div>
          </div>
        </div>
        <button className="modal-close is-large" aria-label="close" onClick={this.props.hideImageGallery}></button>
      </div>
    )
  }
}

export default ImageModal;


// WEBPACK FOOTER //
// ./src/app/components/image-modal/index.js